(function(){
"use strict";
/* La soglia dichiarata e' 85%: non serve piu' riscriverla dopo il
   caricamento, il testo sorgente dice gia' 85. File lasciato vuoto per
   non rompere i richiami che lo caricano. */
})();
